import { IconExternalLink } from '@tabler/icons-react'
import { motion } from 'motion/react'

import { AnimatedText, AstraButton } from '~/astra'
import env from '~/env'

export const TitleSection = () => {
    const useReducedMotion = env.VITE_NO_UNSTABLE_EFFECTS

    return (
        <div className="flex h-56 w-fit flex-col items-center justify-between gap-7 md:items-start md:gap-14">
            {useReducedMotion ? (
                <div className="flex flex-col">
                    <h1 className="auth-hero w-fit text-left leading-none">Mer behandling.</h1>
                    <h1 className="auth-hero w-fit text-left leading-none">Mindre venting.</h1>
                </div>
            ) : (
                <div className="flex flex-col">
                    <AnimatedText
                        as="p"
                        variant="type"
                        caret={false}
                        delay={1}
                        speed={12}
                        textClassName="leading-none text-left w-fit auth-hero "
                        text="Mer behandling."
                    />
                    <AnimatedText
                        as="p"
                        variant="type"
                        caret={false}
                        delay={2.75}
                        speed={12}
                        textClassName="leading-none text-left w-fit auth-hero "
                        text="Mindre venting."
                    />
                </div>
            )}
            <motion.div
                initial={useReducedMotion ? undefined : { opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.8, delay: 0.5 } }}
                className="flex justify-center"
            >
                <AstraButton
                    size="large"
                    variant="ghost"
                    label="Brukerdokumentasjon"
                    icon={<IconExternalLink />}
                    onClick={() => window.open('https://help.deepinsight.io', '_blank')}
                />
            </motion.div>
        </div>
    )
}
